const COMPLEXITY_VALUES = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
} as const;

export default COMPLEXITY_VALUES;
